import {
    BorderRadiusMedium,
    ColorAdvice1,
    ColorAdvice4,
    ColorNordicGrey1,
    ColorNordicGrey4,
    ColorSystemAttention3,
    ColorSystemAttention5,
    ColorSystemNegative4,
    ColorSystemNegative5,
    ColorSystemPositive4,
    ColorSystemPositive5,
    FontWeightNormal,
    Spacing16,
    Spacing8
} from 'autogen/design-tokens/tokens';
import styled, { css } from 'styled-components';
import { breakpoint, sizes } from 'variables';
import { Typography } from '../typography';
import Tag from '../tag';

export type ColoredInfoboxProps = {
    text: string;
    tagText?: string;
    variant?: 'Info' | 'Positive' | 'Attention' | 'Negative';
};
function getBackgroundColor(variant: ColoredInfoboxProps['variant']) {
    switch (variant) {
        case 'Info':
            return ColorAdvice4;
        case 'Positive':
            return ColorSystemPositive5;
        case 'Attention':
            return ColorSystemAttention5;
        case 'Negative':
            return ColorSystemNegative5;
        default:
            return ColorNordicGrey4;
    }
}

function getTagColor(variant: ColoredInfoboxProps['variant']) {
    switch (variant) {
        case 'Info':
            return ColorAdvice1;
        case 'Positive':
            return ColorSystemPositive4;
        case 'Attention':
            return ColorSystemAttention3;
        case 'Negative':
            return ColorSystemNegative4;
        default:
            return ColorNordicGrey1;
    }
}

const StyledTitle = styled(Typography.Title)`
    font-weight: ${FontWeightNormal};
`;

const Wrapper = styled.div<{ $variant: ColoredInfoboxProps['variant'] }>`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: start;
    gap: ${Spacing8};
    padding: ${Spacing16};
    width: 100%;
    border-radius: ${BorderRadiusMedium};

    ${({ $variant }) =>
        css`
            background-color: ${getBackgroundColor($variant)};
        `}

    ${breakpoint.up(sizes.md)} {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
`;

function ColoredInfobox(props: ColoredInfoboxProps) {
    const { variant, text, tagText, ...restProps } = props;

    return (
        <Wrapper $variant={variant} {...restProps}>
            <StyledTitle size="M">{text}</StyledTitle>
            {tagText && <Tag backgroundColor={getTagColor(variant)}>{tagText}</Tag>}
        </Wrapper>
    );
}

export default ColoredInfobox;
